import { useQuery } from '@apollo/client';

import { EventProduct, getUpcomingPopupEventDetails } from '@/api';

import { PopupEventVendorDetailsUpcoming } from '../types';
import { parseEventVendorIds } from '../helpers';

type UsePopupUpcomingEvent = {
  event: PopupEventVendorDetailsUpcoming | undefined;
  loading: boolean;
};

// The route param can carry several ids for aggregated delivery cards, so the
// query takes a list. POPUP events are not aggregated, hence the first result.
export const usePopupUpcomingEvent = (id: string): UsePopupUpcomingEvent => {
  const { data, loading } = useQuery(getUpcomingPopupEventDetails, {
    variables: { input: { eventVendorIds: parseEventVendorIds(id), productType: EventProduct.POPUP } },
  });

  return {
    event: data?.getEventVendors?.eventVendors?.[0] as PopupEventVendorDetailsUpcoming | undefined,
    loading,
  };
};
